module.exports = __webpack_public_path__ + "img/cosmicds_logo_for_dark_backgrounds.682eed66.png";